import base from '../dr-base'
import drTimePicker from './dr-time-picker.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-time-picker',
  name: 'Time picker',
  group: 'Input widgets',
  icon: 'clock',
  ...base,
  properties: {
    ...base.properties,
    Seconds: {
      name: 'vuetifyWidgets.dr-time-picker.seconds',
      type: 'boolean',
      default: false
    },
    IsClearable: {
      name: 'Clearable',
      type: 'boolean',
      default: false
    },
    Disabled: {
      name: 'vuetifyWidgets.dr-time-picker.disabled',
      type: 'string',
      default: ''
    },
    Value: {
      type: 'string',
      name: 'vuetifyWidgets.dr-time-picker.value',
      component: 'dr-value-editor'
    },
    Caption: {
      type: 'string',
      name: 'vuetifyWidgets.dr-time-picker.caption'
    },
    Style: {
      name: 'vuetifyWidgets.dr-time-picker.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-time-picker.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drTimePicker,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
